import { createSlice } from '@reduxjs/toolkit';

import { authActions } from '../auth/index.js';

export type EvaluationsState = any;

const evaluationsDefaultState: EvaluationsState = {};

const { reducer: evaluationsReducer, actions: evaluationsActions } = createSlice({
    name: 'evaluations',
    initialState: evaluationsDefaultState,
    reducers: {},
    extraReducers: (builder) => builder.addCase(authActions.PurgeProfile, () => evaluationsDefaultState),
});

export { evaluationsReducer, evaluationsActions, evaluationsDefaultState };
